export default {
  getProjectName: (state) => (id) => {
    var project = state.projects?.find((project) => project.projectId == id);
    if (!project) return "";
    return project.name;
  },
};
